import { render, staticRenderFns } from "./configs.vue?vue&type=template&id=ee7c6d18&scoped=true"
import script from "./configs.vue?vue&type=script&lang=js"
export * from "./configs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7c6d18",
  null
  
)

export default component.exports